module.exports = __webpack_public_path__ + "static/media/UBE.b965837c.jpg";